export default {
  landscape: 'Krajobraz',
  portrait: 'Portret',
};
